// Copyright (c) 2017 Deere & Company

import './modal-body.scss';
import React, {PropTypes} from 'react';
import ClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval';
import LabeledString from '../../../../shared/components/labeled-string';

const SpaModalBody = props =>
    <section className='modal-body'>
        <section className='claim-info'>
            <LabeledString
                data={props.claimForApproval.claimNumber}
                label='SPECIAL_ALLOWANCE_CLAIM'
            />
            <LabeledString
                data={props.claimForApproval.pin}
                label='PIN'
            />
            <LabeledString
                data={props.claimForApproval.responsibleAccount.account}
                label='RESPONSIBLE_DEALER'
            />
        </section>
    </section>;

SpaModalBody.displayName = 'SpaModalBody';
SpaModalBody.propTypes = {
    claimForApproval: PropTypes.instanceOf(ClaimForApproval).isRequired
};

export default SpaModalBody;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/modal/modal-body.js